<template>


  <div class="container container-tabs">



    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in port_data" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>





      <div class="handle-box">

        <el-row class="head-search">
          <el-col :span="16">
            <span class="title">标题:</span>
            <!-- 搜索标题 -->
            <el-input v-model="search_data.title" placeholder="请输入标题" class="handle-input mr10" @keyup.enter.native="searchArticleLists"></el-input>
          </el-col>
          <el-col :span="6">
            <el-button :class="more_search?'el-icon-arrow-up':'el-icon-arrow-down'" @click="more_search = !more_search">
              详细搜索
            </el-button>
          </el-col>
        </el-row>

        <div v-show="more_search" style="margin-top: 10px;">


          <!-- 搜索推送 -->
          <el-row class="head-search">

            <el-col :span="24" style="margin: 10px 0;">
              <span class="title">推送:</span>
              <el-radio-group v-model="search_data.push" size="small">
                <el-radio label="" border>
                  全部</el-radio>
                <el-radio v-for="(item, index) in val_push_array" :key="index" :label="String(item.val)" border>
                  {{ item.alias }}</el-radio>
              </el-radio-group>
            </el-col>

            <!-- 搜索置顶级别 -->


            <el-col :span="24" style="margin: 10px 0;">
              <span class="title">推荐:</span>
              <el-radio-group v-model="search_data.top" size="small">
                <el-radio label="" border>
                  全部</el-radio>
                <el-radio v-for="(item, index) in val_top_array" :key="index" :label="String(item.val)" border>
                  {{ item.alias }}</el-radio>
              </el-radio-group>
            </el-col>

          </el-row>
        </div>














        <el-button type="primary" icon="el-icon-search" @click="searchArticleLists">搜索</el-button>
        <el-button @click="addArticleDrawer">添加</el-button>
        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

      </div>


    </el-tabs>






    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" prop="notice_code"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div class="more-style">

              <el-form-item label="创建时间:">
                <span>{{ props.row.time.Ymd }}</span>
              </el-form-item>

              <el-form-item label="创建详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>


            </div>

          </el-form>
        </template>
      </el-table-column>


      <el-table-column prop="id" label="id" width="80">
      </el-table-column>


      <el-table-column prop="title" label="标题" width="200">

        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>唯一编码: {{ scope.row.notice_code }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.title }}</el-tag>
            </div>
          </el-popover>
        </template>

      </el-table-column>

      <el-table-column prop="keywords" label="副标题" min-width="200">
      </el-table-column>


      <el-table-column prop="top.alias" label="置顶级别">
      </el-table-column>


      <el-table-column prop="port.alias" label="端口">
      </el-table-column>

      <el-table-column prop="weights" label="权重">
      </el-table-column>

      <el-table-column prop="push.alias" label="推送">
      </el-table-column>




      <el-table-column label="操作" width="150">
        <template slot-scope="scope">



          <el-dropdown split-button type="primary"
            @click="editArticle_isShow = !editArticle_isShow; editArticle_drawer = scope.row.notice_code"
            trigger="click">

            编辑

            <el-dropdown-menu slot="dropdown">


              <el-dropdown-item
                @click.native="articleContent_isShow = !articleContent_isShow; articleContent_body = scope.row.content;">
                公告内容
              </el-dropdown-item>

              <el-dropdown-item
                @click.native="pushAgain(scope.row.notice_code)">
                再次推送
              </el-dropdown-item>



            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>

    </el-table>

    <!-- 批量删除按钮 -->
    <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
      style="margin-top: 20px;">批量删除</el-button>


    <!-- 分页组件 -->
    <div class="pagination">

      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>

    </div>




    <!-- 添加文章组件 -->
    <addArticle :isShow="addArticle_isShow" @onSubmit="articleLists"></addArticle>

    <!-- 编辑文章组件 -->
    <editArticle :data="editArticle_drawer" :isShow="editArticle_isShow" @onSubmit="articleLists"></editArticle>

    <!-- 文章内容组件 -->
    <articleContent :data="articleContent_body" :isShow="articleContent_isShow"></articleContent>


  </div>


</template>

<script>
  import addArticle from './addArticle.vue';
  import editArticle from './editArticle.vue';
  import articleContent from './articleContent.vue';
  var _this;
  export default {
    components: {
      articleContent,
      addArticle,
      editArticle
    },
    data() {
      return {

        // 选项卡默认选中项
        activeName: 'all',

        // 搜索端口
        port_data: [],

        //详细搜索
        more_search: false,

        // 文章内容开关
        articleContent_isShow: false,

        // 添加文章组件
        addArticle_isShow: false,

        // 修改文章组件
        editArticle_isShow: false,

        articleContent_body: '',




        // 搜索推送
        val_push_array: '',

        // 搜索置顶级别
        val_top_array: '',




        // 传入编辑组件的内容
        editArticle_drawer: '',

        mode_price: '',

        // 批量删除
        delAdvertSubmit_data: {
          notice_code_array: []
        },
        delAdvertSubmit_rules: {
          notice_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          title: '',
          port:'',
          push:'',
          top:''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;

      _this.articleLists();
      console.log(_this.port_data);


    },

    methods: {

      // 再次推送
      pushAgain(code){

        _this.$post(
            "/notice/pushAgain", {
              notice_code: code
            }
          ).then(res => {

            _this.$message.success(res.msg);

            // _this.articleLists();

          }).catch((err) => {

          })

      },

      searchArticleLists(){

        _this.search_data.page = 1;

        _this.articleLists();

      },




      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.port = tab.name;
        } else {
          _this.search_data.port = '';
        }
        _this.search_data.page = 1;
        _this.articleLists();

      },

      // 添加按钮方法
      addArticleDrawer() {

        _this.addArticle_isShow = !_this.addArticle_isShow;

      },

      // 获取模式
      articleLists() {

        _this.$post(
            "/notice/noticeLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.port_data = res.data[0].port.select_array;
            _this.val_push_array = res.data[0].push.select_array;
            _this.val_top_array = res.data[0].top.select_array;



            console.log(res.data);




          }).catch((err) => {

          })

      },

      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;

        //初始化列表
        _this.articleLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].notice_code);

        }
        _this.delAdvertSubmit_data.notice_code_array = datalist;
      },

      // 批量删除
      deleteData() {
        console.log(_this.delAdvertSubmit_data);

        if (_this.delAdvertSubmit_data.notice_code_array.length == 0) {

          _this.$message.warning('请至少勾选一条数据');

          return;
        }


        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {
          _this.delAdvertSubmit_data.notice_code_array = JSON.stringify(_this.delAdvertSubmit_data.notice_code_array);

          _this.$post(
              "/notice/deleteNoticeSubmit",
              _this.delAdvertSubmit_data,
              _this.delAdvertSubmit_rules
            )
            .then(res => {

              _this.$message.success('删除成功!');

              //初始化显示列表
              _this.articleLists();

            }).catch((err) => {

            })

        }).catch(() => {

          _this.$message.info('已取消删除');

        });

      },


      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>